import { EP } from "../configs/constant";
import { getPath } from "../helpers/handleUrl";
import { ICategoryResponse } from "../types/category";
import axiosService, { AxiosService } from "./axiosService";
class CategorySevice {
    readonly service: AxiosService;
    constructor() {
        this.service = axiosService;
    }
    getCategories() {
        return this.service.get<ICategoryResponse>(getPath(EP.CATEGORY, EP.LIST))
    }
    getProductsByCategory(categoryId: number) {
        return this.service.get<ICategoryResponse>(getPath(EP.CATEGORY, EP.PRODUCT, {
            query: {
                category_id: categoryId,
                limit: 4,
            }
        }))
    }
}
const categoryService = new CategorySevice();
export default categoryService;